import { Timestamp } from 'firebase/firestore';

export const INVOICE_TYPES = ['prepayment', 'final', 'bpi'] as const;
export type InvoiceType = (typeof INVOICE_TYPES)[number];

export const CURRENCIES = ['EUR', 'USD', 'RMB'] as const;
export type Currency = (typeof CURRENCIES)[number];

export interface Invoice {
  id: string;
  designationId: string;
  invoiceNumber: string;
  invoiceDate: Timestamp;
  invoiceAmount: number;
  paymentDate?: Timestamp;
  type: InvoiceType;
  currency: Currency;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}
